<template>
  <div>
    <fieldset class="pl-3">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="quarterlystart"
              >Client quarterly start:</label
            >
            <b-select
              name="quarterlystart"
              class="form-select"
              v-model.number="client.quarterlystart"
            >
              <option selected value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="row mt-3 pl-3">
        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showdashboard">Dashboard:</label>

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showDashboard"
            v-model="client.showDashboard"
          />
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showtraining"
            >Training module:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showtraining"
            v-model="client.showtraining"
          />
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showNominations"
            >Nominations module:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showNominations"
            v-model="client.showNominations"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showsearch">Show search:</label>

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showsearch"
            v-model="client.showsearch"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showrproductpoints"
            >Show product points:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showrproductpoints"
            v-model="client.showrproductpoints"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showdescription"
            >Show program description:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showdescription"
            v-model="client.showdescription"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showbb"
            >Show bulletin board:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showbb"
            v-model="client.showbb"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="mallLogo"
            >Use logo on mall page:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="mallLogo"
            v-model="client.mallLogo"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="processorders"
            >Process orders:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="processorders"
            v-model="client.processorders"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="capturessnfedid"
            >Capture SSN/Federal ID:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="0"
            :true-value="1"
            role="switch"
            name="capturessnfedid"
            v-model="client.capturessnfedid"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="forceEmail">Force Email:</label>

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="forceEmail"
            v-model="client.forceEmail"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="require_pid_bathctool"
            >Require program ID in batch upload:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="require_pid_bathctool"
            v-model="client.require_pid_batchtool"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="hidePoints"
            >Remove points:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="hidePoints"
            v-model="client.hidePoints"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="security"
            >Require 90 day password change:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="security"
            v-model="client.security"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showServicesAwards"
            >Service awards:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showServiceAwards"
            v-model="client.showServicesAwards"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="serviceawardsingleorder"
            >Service awards single order:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="serviceawardsingleorder"
            v-model="client.serviceawardsingleorder"
          />
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showSocialRecognition"
            >Show social recognition:</label
          >

          <b-form-checkbox
            class="ml-2"
            switch
            :false-value="false"
            :true-value="true"
            role="switch"
            name="showSocialRecognition"
            v-model="client.showSocialRecognition"
          />
        </div>

        <div class="col-md-4 mt-3">
          <label class="form-label" for="socialRecognitionScope"
            >Social Recognition Scope:</label
          >
          <b-select
            name="socialRecognitionScope"
            multiple
            class="form-select"
          ></b-select>
        </div>

        <div class="col-md-12 text-center mt-3">
          <p><strong>(Remember to upload the logo)</strong></p>
        </div>

        <div class="row col-md-12">
          <div class="col-md-6">
            <label class="form-label" for="bulletin">Bulletin:</label>
            <b-select class="form-select" v-model.number="client.bulletin">
              <option selected value="0">None</option>
              <option value="1">Wishlist</option>
              <option value="2">What's New</option>
              <option value="3">What's New</option>
            </b-select>
          </div>
        </div>

        <div class="row ml-2" style="width: 100%;">
          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="allowTax"
              >Allow tax payment:</label
            >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowtax"
              v-model="client.allowTax"
            />
          </div>

          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="allowTaxPartial"
              >Allow partial tax payment:</label
            >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowtaxPartial"
              v-model="client.allowTaxPartial"
            />
          </div>

          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="grossUpTax"
              >Gross-up taxes:</label
            >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="grossUpTax"
              v-model="client.grossUpTax"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12" style="width: 50%;">
          <div class="col-md-5 d-flex align-items-center">
            <label for="taxPercentage" class="form-label"
              >Tax percentage:</label
            >
            <input
              type="text"
              class="form-control tax-percentage ml-2"
              name="taxPercentage"
              placeholder="0"
              @click="(e) => check(e)"
              v-model.number="client.taxPercentage"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-5 d-flex align-items-center">
            <label for="minpointvalue" class="form-label"
              >Min point value:</label
            >
            <input
              type="text"
              class="form-control"
              name="minpointvalue"
              maxlength="5"
              v-model.number="client.minpointvalue"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-5 d-flex align-items-center">
            <label for="maxpointvalue" class="form-label"
              >Max point value:</label
            >
            <input
              type="text"
              class="form-control"
              name="maxpointvalue"
              maxlength="5"
              v-model.number="client.maxpointvalue"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-5 d-flex align-items-center">
            <label class="form-check-label" for="maxpointvalue"
              >Force client secure password:</label
            >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showclientsecurepassword"
              v-model="client.showclientsecurepassword"
            />
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "Miscellaneous",
  data() {
    return {};
  },
  computed: {
    client() {
      return this.$store.state.manageClients.client;
    },
  },
  methods: {
    check(e) {
      const element = e.target;

      element.setAttribute("disabled", "");

      alert(
        "Modification the tax percentage once orders have been placed is not allowed."
      );
    },
  },
};
</script>
<style scoped lang="scss">
.mb-4 {
  margin-bottom: 32px !important;
}
</style>
